<!--
  -  Copyright (c) Qwoach LLC 2023. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 3/1/2023
  -->

<template>
	<div v-if="coachProfileData" class="my-5">
		<div class="text-center">
			<div v-if="!hideLogo && (ownerProfile && ownerProfile.logo || coachProfileData && coachProfileData.logo) " >
				<qw-img
					:src="(ownerProfile || coachProfileData).logo.url"
					class="brandLogo text-center"/>
				<hr class="my-3"/>
			</div>
			<div class="qw-row justify-content-center">
				<div v-if="!hidePicture && coachProfileData.userPicture" class="mr-2">
					<qw-img
						:src="coachProfileData.userPicture.url"
						class="avatar"/>
				</div>
				<div v-if="!hideName" style="max-width: 350px">
					<h4>{{coachProfileData.name}} {{customMessage}}</h4>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import UserProfile from "@shared/Profile/UserProfile";

export default {
	name: "CoachLogoView",
	extends: BaseComponent,

	props: {
		ownerProfile: UserProfile,
		coachProfileProp: UserProfile,
		customMessage: String,
		hideName: Boolean,
		hidePicture: Boolean,
		hideLogo: Boolean,
		coachProfileMember: UserProfile,
	},

	data() {
		return {
			coachProfileData: null,
		}
	},

	async mounted(){
		console.log("CoachLogoView mounted: this.coachEmbeddedUid = " + this.coachEmbeddedUid)
		if(this.coachProfileProp || this.coachProfileMember){
			this.coachProfileData = this.coachProfileProp || this.coachProfileMember
		} else if(this.coachEmbeddedUid || this.$route.params.coachId){
			let coachId = this.coachEmbeddedUid || this.$route.params.coachId
			this.coachProfileData = await this.dataManager.apiGetUserProfilePublic({uid: coachId})
		}
	},
}
</script>

<style lang="scss">

</style>
